module.exports = __webpack_public_path__ + "img/gas.4357c508.png";